import {
    IonAvatar,
    IonCol, 
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonNote,
    IonRow,
    IonThumbnail
} from '@ionic/react';
import { chevronForwardOutline } from 'ionicons/icons';
import { ItemInfo } from '../data/item';
import React, { Component }  from 'react';

interface ItemCompProp {
    item: ItemInfo;
    onSubmit : any;
}
  
const ItemComp: React.FC<ItemCompProp> = ({ item, onSubmit }) => {
    return (
        <IonItem onClick={()=>{ onSubmit(item); }} detail={false} lines="none">
            <IonAvatar slot="start">
                <img src={item.avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
            </IonAvatar>
            <IonLabel className="ion-text-wrap">
                <h2>{item.name}</h2>
                <IonNote>{item.info}</IonNote>
            </IonLabel>
            <IonIcon slot="end" icon={chevronForwardOutline}/>
        </IonItem>
    );
};
  
export default ItemComp;